import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Services Grid (desktop) - staggered fade in with slide from bottom and rotation
 */
export const animateServicesGrid = (ref, isMobile, isLoading, safeServicesData) => {
  if (ref.current && !isMobile && !isLoading && safeServicesData.length > 0) {
    // Set initial state immediately to prevent flash
    const cards = ref.current.querySelectorAll('[class*="mainCard"]');
    if (cards.length > 0) {
      gsap.set(cards, { opacity: 0, y: 80, rotation: -5 });
    }
    
    const timer = setTimeout(() => {
      if (cards.length > 0) {
        gsap.to(cards, {
          opacity: 1,
          y: 0,
          rotation: 0,
          duration: 0.9,
          stagger: 0.15,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        ScrollTrigger.refresh();
      }
    }, 200);
    
    return () => clearTimeout(timer);
  }
};

